<script context="module" lang="ts">
	import MetaTags from '$lib/components/utils/MetaTags.svelte';
	import Wrapper from '$lib/components/utils/ResponsiveWrapper.svelte';

	import { onMount } from 'svelte';
</script>

<script lang="ts">
	onMount(async () => {
		setTimeout(function () {
			window.location.href = 'https://app.connecteam.com/';
		}, 3000);
	});
</script>

<MetaTags title="Staff Portal" />

<Wrapper title="Staff Portal">
	<div class="relative z-0 mt-8 rounded bg-white pb-4 pt-4">
		<h2 class="mt-4 text-center text-neutral-900 dark:text-white">
			You are being redirected to the staff portal...
		</h2>
		<p class="mb-4 mt-4 text-center text-neutral-700 dark:text-neutral-200">
			If you are not redirected in 3 seconds please <a href="https://app.connecteam.com/"
				>click here</a
			>.
		</p>
	</div>
</Wrapper>
